<template>
    <div class="m-task">
        <h5 class="title"></h5>
        <div class="slogen">
            <p>回归老兵完成相应任务，双方均可获得情义积分奖励。（所有身份玩家每个奖励只可领取一次，未被招募的回归玩家也可单独完成任务）</p>
        </div>

        <div class="page-view">
            <div class="task-list">
                <div class="task-item" v-for="(task,index) in task_config" :key="index">
                    <h6 class="task-title" :class="'task-' + (index + 1)"></h6>
                    <div class="task-info">（{{ task.taskName }}：{{ task.rate }}/{{ task.conditionValue }}）</div>

                    <div class="task-head" :class="'task-' + (index + 1)"></div>

                    <div class="pro-view">
                        <div class="bar">
                            <div class="bar-body" :style="{'width' : pro[task.finishRate] + '%'}"></div>
                            <div class="bar-icon" :class="'i-' + (index + 1)" :style="{'left' : rate[task.finishRate] + '%'}"></div>
                        </div>

                        <div class="gift-view">
                            <div class="reward-item" v-for="(r,i) in task.subList" :key="i" :class="{'dismiss' : (task.giftRate) > i  , 'act' : i < (task.finishRate) && i >= (task.giftRate) }">
                                <div class="reward-wrapper">
                                    <game-item :id="r.giftList[0].giftId" :num="r.giftList[0].sendNum" :locked="true"></game-item>
                                </div>
                            </div>
                        </div>

                        <div class="u-btn apply" :class="{'disabled' : task.giftRate == task.finishRate}" @click="task_apply(task.taskOrderId,task.subList,task.giftRate,task.finishRate)"></div>
                    </div>
                </div>
            </div>


            <div class="task-notice">
                <p>温馨提醒：非回归招募者需任意一位回归玩家被招募后完成任务；回归玩家可自己或招募其他回归玩家完成任务。</p>
            </div>
        </div>
    </div>
</template>

<style scoped>
.title{
    width: 1111px;
    height: 173px;
    margin: 0 auto 20px;
    background-image: url(~@/assets/images/pc/title-3.png);
}

.task-list{
    display: flex;
    justify-content: space-between;
    width: 1200px;
    margin: 45px auto 0;
}

.task-item{
    position: relative;
    width: 560px;
    height: 485px;
    padding-top: 45px;
    box-sizing: border-box;
    background-image: url(~@/assets/images/pc/task-item.png);
}

.u-btn.apply{
    position: absolute;
    left: 50%;
    bottom: 42px;
    width: 239px;
    height: 84px;
    margin-left: -123.5px;
    background-image: url(~@/assets/images/pc/btn-task_apply-2.png);
}

.u-btn.apply.disabled{
    /* bottom: 62px;
    width: 235px;
    height: 63px;
    margin-left: -117.5px;    
    filter: none;
    background-image: url(~@/assets/images/pc/btn-task_apply-2_disabled.png); */
}

.task-title.task-1{
    width: 516px;
    height: 58px;
    margin: 0 auto;
    background-image: url(~@/assets/images/pc/task-1.png);
}

.task-title.task-2{
    width: 516px;
    height: 58px;
    margin: 0 auto;
    background-image: url(~@/assets/images/pc/task-2.png);
}

.task-info{
    margin: 10px auto 40px;
    text-align: center;
    font-size: 16px;
    color: #49392e
}

.bar{
    position: relative;
    width: 483px;
    height: 18px;
    margin: 0 auto;
    background-image: url(~@/assets/images/pc/bg-bar.png);
}

.bar-body{
    position: absolute;
    left: 2px;
    top: 50%;
    width: 479px;
    height: 14px;
    margin-top: -7px;
    background-color: #216763;
    border-radius: 10px;
}

.bar-icon{
    position: absolute;
    left: 4px;
    top: 50%;
    transform: translateY(-50%);
    margin-left: -2px;
    background-image: url(~@/assets/images/pc/icon-blade.png);    
}

.bar-icon.i-1{
    width: 39px;
    height: 41px;
    background-image: url(~@/assets/images/pc/icon-blade.png);   
}

.bar-icon.i-2{
    width: 32px;
    height: 41px;
    margin-top: -4px;
    background-image: url(~@/assets/images/pc/icon-bag.png);   
}

.gift-view{
    display: flex;
    justify-content: space-between;
    margin-top: 25px;
    padding: 0 53px;
}

.reward-item{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 70px;
    height: 70px;
    background-image: url(~@/assets/images/pc/bg-item.png);  
}

.dismiss .reward-wrapper::after{
    content: '';
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    width: 46px;
    height: 46px;
    transform: translate(-50%,-50%);
    background-color: rgba(0, 0, 0, 0.8);
    background-image: url(~@/assets/images/pc/icon-get.png);
    background-repeat: no-repeat;
    background-position: center;
}

.reward-wrapper{
    width: 46px;
    height: 46px;
}

.task-notice{
    position: relative;
    width: 960px;
    height: 121px;
    line-height: 121px;
    margin: 40px auto 0;
    font-size: 0;
    color: transparent;
    box-sizing: border-box;
    background-image: url(~@/assets/images/pc/bg-invite-notice.png);
    text-align: center;
}

.task-notice::after{
    /* content: '';
    display: block;
    position: absolute;
    left: 100px;
    top: 50%;
    width: 60px;
    height: 56px;
    margin-top: -28px;
    background-image: url(~@/assets/images/pc/icon-notice.png);  */
}

.task-head{
    margin: 0 auto 8px
}

.task-head.task-1{
    width: 418px;
    height: 41px;
    background-image: url(~@/assets/images/pc/head-task_1.png); 
}

.task-head.task-2{
    width: 439px;
    height: 41px;
    background-image: url(~@/assets/images/pc/head-task_2.png); 
}
</style>

<script>
export default {
    data (){
        return {
            task_config : [],
            rate : [0,10,47,84],
            pro : [0,15,50,99.1]
        }
    },
    mounted(){
        this.render();
    },
    methods : {
        render (){
            var _this = this;
            this.$axios.get(ajax_url_map.task_info,{ params : { s : true, } })
            .then(res => {
                this.task_config = res.data ? res.data.splice(0,2) : [];
            },rej => {
                _this.$toast(rej.message)
            });            
        },
        task_apply(tid,list,start,end){

            if(!this.$store.state.login){
                return this.$mslogin.open();
            }
            if(!this.$store.state.userinfo.zid){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            if(!tid){                
                return this.$toast('请先完成任务，再领取奖励');
            }

            
            let result = [];

            for(var i = start ; i < end ; i++){
                result.push(list[i].giftList[0]);
            }

            this.$axios.post(ajax_url_map.task_apply,{
                orderId : tid
            })
            .then(
                res => {
                    this.$success_modal({'text' : '奖励已发放至活动页面，请及时领取' , giftList : result});
                    this.$update_user();
                    this.render();
                },
                rej => {
                    this.$toast(rej.message);
                }
            )        
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/view/task.vue